export default __webpack_public_path__ + "0dc146b61b8e14ebd0a96f6acd1dc065.png";